import { Link as RouterLink } from 'infrastructure/router';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// routes
// import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import { CustomAvatar } from 'lib/custom-avatar';
import { WebRoutes } from 'consts/enpoints/web';
import useUser from 'features/auth/useUser';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user, getUserName } = useUser();

  return (
    <Link to={WebRoutes.Root} component={RouterLink} underline="none" color="inherit">
      <StyledRoot>
        <CustomAvatar alt={getUserName()} name={getUserName()} />

        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {getUserName()}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            {user.roleName}
          </Typography>
        </Box>
      </StyledRoot>
    </Link>
  );
}
